export default "__VITE_ASSET__ZOwBW5qi__"